import artworkActions from './artworkActions';
import categoryActions from './categoryActions';
import shellActions from './shellActions';
import faceplateActions from './faceplateActions';
import cableActions from './cableActions';
import finalizeAction from './finalizeActions';
import modelActions from './modelActions';
import settingsActions from './settingsActions';
import priceActions from './priceActions';
import impressionActions from './impressionStatusActions';
import rushActions from './rushActions';
import customLayerActions from './customArtworkActions';
import previewActions from './previewActions';

const allActions = {
    modelActions,
    categoryActions,
    faceplateActions,
    shellActions,
    cableActions,
    finalizeAction,
    settingsActions,
    artworkActions,
    priceActions,
    impressionActions,
    rushActions,
    customLayerActions,
    previewActions
};

export default allActions;
